import {
  Link,
  SessionRole,
  SessionLogout,
  Wrapper,
  Icon,
} from "nystem-components";
import app from "nystem";

const NavbarLink = ({ children, type, icon, ...props }) => {
  const classNames = "px-1 md:px-5 py-2 hover:shadow flex items-center";

  if (type)
    props = { ...props, to: `/admin/${type}/list`, match: `/admin/${type}/*` };

  return (
    <Link
      {...props}
      className={[
        classNames,
        props.className,
        "hover:bg-white/30 hover:shadow navlink",
      ]}
    >
      <Icon icon={icon} className="mx-1 md:mx-0 md:mr-3 h-4 w-4" />
      <Wrapper className="hidden md:block flex-grow">{children}</Wrapper>
    </Link>
  );
};

const PartAdminMenu = () => {
  return (
    <SessionRole userrole="config super">
      <Link
        to="/admin"
        className={
          "hover:bg-white/30 hover:shadow md:px-5 px-3 text-xl font-semibold sm:text-base flex md:mt-2"
        }
      >
        <Icon icon="gear" className="mr-1 md:mr-3 h-4 w-4 my-auto" />
        <Wrapper className="flex-grow">{app.t("Admin")}</Wrapper>
      </Link>
      <NavbarLink icon="newspaper" type="news">
        {app.t("News")}
      </NavbarLink>
      <NavbarLink icon="file" type="page">
        {app.t("Page")}
      </NavbarLink>
      <NavbarLink icon="user" type="user">
        {app.t("People")}
      </NavbarLink>
      <NavbarLink icon="building-columns" type="partner">
        {app.t("Partner")}
      </NavbarLink>
      <Wrapper className="h-6" />
      <NavbarLink icon="file" type="content">
        {app.t("Content")}
      </NavbarLink>
      <NavbarLink icon="list" type="menu">
        {app.t("Menu")}
      </NavbarLink>
      <NavbarLink icon="tag" type="tag">
        {app.t("Tag")}
      </NavbarLink>
      <Wrapper className="h-6 flex-grow" />
      <SessionLogout
        type="button"
        className="px-1 md:px-5 py-2 hover:shadow flex items-center hover:bg-white/30"
        to="/"
      >
        <Icon icon="right-from-bracket" className="mr-3 h-4 w-4" />
        <Wrapper className="hidden md:block flex-grow">
          {app.t("Logout")}
        </Wrapper>
      </SessionLogout>
    </SessionRole>
  );
};

export default PartAdminMenu;
